import React from "react";

export const ThinkingEmojiSvg = ({ width, height }) => {
  return (
    <svg
      width={width ?? "109"}
      height={height ?? "109"}
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2002_2339611)">
        <path
          d="M56.5 106.777C85.9706 106.777 109.861 82.8863 109.861 53.4158C109.861 23.9453 85.9706 0.0546875 56.5 0.0546875C27.0295 0.0546875 3.13892 23.9453 3.13892 53.4158C3.13892 82.8863 27.0295 106.777 56.5 106.777Z"
          fill="#FFC700"
        />
        <path
          d="M45.5892 66.0278C45.1341 65.6637 44.7794 65.1678 44.6099 64.5714C44.1893 63.1275 45.0179 61.6899 46.4618 61.3666C60.6747 58.1618 70.2452 65.6449 70.6501 65.965C71.8554 66.9255 72.0908 68.6174 71.1931 69.7474C70.2954 70.8711 68.5941 71.0061 67.3919 70.0519C67.0466 69.7882 59.4725 64.0158 47.9873 66.6054C47.1273 66.7968 46.2484 66.5551 45.5892 66.0278Z"
          fill="#4C0A0A"
        />
        <path
          d="M41.1792 43.4091C44.863 43.4091 47.8493 39.6766 47.8493 35.0722C47.8493 30.4679 44.863 26.7354 41.1792 26.7354C37.4954 26.7354 34.509 30.4679 34.509 35.0722C34.509 39.6766 37.4954 43.4091 41.1792 43.4091Z"
          fill="#4C0A0A"
        />
        <path
          d="M76.5104 46.7441C80.1942 46.7441 83.1805 43.0115 83.1805 38.4072C83.1805 33.8029 80.1942 30.0703 76.5104 30.0703C72.8266 30.0703 69.8403 33.8029 69.8403 38.4072C69.8403 43.0115 72.8266 46.7441 76.5104 46.7441Z"
          fill="#4C0A0A"
        />
        <path
          d="M54.2275 110.327C54.2275 110.327 58.1982 109.037 58.713 106.084C59.256 103.033 56.7543 102.421 56.7543 102.421C56.7543 102.421 60.0219 101.768 60.4331 98.1015C60.8192 94.6456 57.7305 93.8232 57.7305 93.8232C57.7305 93.8232 60.7752 92.5677 60.9196 88.9925C61.0389 85.9823 57.7964 84.5101 57.7964 84.5101C57.7964 84.5101 73.6101 80.6776 75.2361 80.3009C76.8558 79.9242 79.3794 78.3705 78.5916 74.9836C77.81 71.5936 74.8123 71.4743 73.2649 71.8353C71.7143 72.1963 52.0962 76.7508 45.3288 78.3265L40.8119 79.3749C39.1169 79.7736 38.3479 79.0296 39.5438 77.7678C41.1383 76.0854 42.1585 74.224 42.5132 71.1353C42.8867 67.8866 41.785 63.8751 41.154 62.3182C39.9801 59.4273 37.9995 57.1422 35.7112 56.3574C32.1423 55.1333 29.6061 57.365 30.871 61.2572C32.7669 67.0767 31.5239 71.851 28.2563 74.7325C20.5692 81.5031 16.994 86.3307 19.3733 96.62C21.9723 107.841 33.1122 115.064 44.3337 112.465L54.2275 110.327Z"
          fill="#E6B300"
        />
        <path
          d="M29.1791 19.9338C28.6643 19.6575 28.228 19.2306 27.9518 18.6813C27.2738 17.3379 27.8262 15.7716 29.1854 15.1909C42.5759 9.44359 53.3517 15.0559 53.8037 15.2976C55.1628 16.0227 55.7121 17.6424 55.031 18.9199C54.353 20.1911 52.7082 20.6337 51.3491 19.9181C50.963 19.7203 42.4597 15.4232 31.6431 20.0656C30.8364 20.4077 29.9262 20.3324 29.1791 19.9338ZM67.2695 31.7046C66.7799 31.397 66.3718 30.9418 66.1333 30.3737C65.5463 28.9863 66.2054 27.464 67.6023 26.9711C81.3537 22.1498 91.7246 28.4778 92.1578 28.7509C93.4604 29.567 93.8999 31.2212 93.1371 32.4485C92.3775 33.6727 90.7013 34.0023 89.3987 33.1956C89.022 32.9696 80.8389 28.1074 69.7273 32.0059C68.8923 32.2916 67.9915 32.1503 67.2695 31.7046Z"
          fill="#4C0A0A"
        />
      </g>
      <defs>
        <clipPath id="clip0_2002_2339611">
          <rect width="109" height="109" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
